export enum SecurityGroupStatus {
    OnCloud = 'On cloud',
    NotOnCloud = 'Not on cloud',
    PendingToCreate = 'Pending to create',
    PendingToUpdate = 'Pending to update',
    PendingDelete = 'Pending deletion'
}
